import { types, API_URL } from './types';
import { axiosApi } from './index';

export const userCreate = (email, password, role, name, phone) => {
  const url = `${API_URL}/api/users`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      email: email,
      password: password,
      role: role,
      name: name,
      phone: phone,
    };
    axiosApi.post(url, params).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setUserCreate(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['user'] = data.user;
        dispatch(setUserCreate(outputData));
      }
    }).catch((err) => {
      dispatch(setUserCreate({ status: 'danger', message: err.response?.data?.message || 'Error de conexión' }));
    });
  };
};

export const setUserCreate = (data) => ({
  type: types.userCreate,
  payload: data,
});

export const userList = () => {
  const url = `${API_URL}/api/users`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.get(url).then(({ data }) => {
      let dataList = [];
      data.users.map((user) => dataList.push(user));

      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setUserList(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data.users;
        dispatch(setUserList(outputData));
      }
    }).catch((err) => {
      dispatch(setUserList({ status: 'danger', message: err.response?.data?.message || 'Error de conexión', data: [] }));
    });
  };
};

export const setUserList = (data) => ({
  type: types.userList,
  payload: data,
});

export const roles = () => {
  const url = `${API_URL}/api/auth/roles`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setRoles(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['roles'] = data.roles;

        dispatch(setRoles(outputData));
      }
    }).catch((err) => {
      dispatch(setRoles({ status: 'danger', message: err.response?.data?.message || 'Error de conexión', roles: [] }));
    });
  };
};

export const setRoles = (data) => ({
  type: types.roles,
  payload: data,
});

export const deleteUser = (data) => {
  const url = `${API_URL}/api/users`;
  let params = {
    data: {
      email: data.email,
    },
  };

  return (dispatch) => {
    let outputData = {};

    axiosApi.delete(url, params).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setDeleteUser(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        dispatch(setDeleteUser(outputData));
      }
    }).catch((err) => {
      dispatch(setDeleteUser({ status: 'danger', message: err.response?.data?.message || 'Error de conexión' }));
    });
  };
};

export const setDeleteUser = (data) => ({
  type: types.deleteUser,
  payload: data,
});

export const userUpdate = (email, password, role, name, phone) => {
  const url = `${API_URL}/api/users`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      email: email,
      password: password,
      role: role,
      name: name,
      phone: phone,
    };
    axiosApi.put(url, params).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setUserUpdate(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['user'] = data.user;
        dispatch(setUserUpdate(outputData));
      }
    }).catch((err) => {
      dispatch(setUserUpdate({ status: 'danger', message: err.response?.data?.message || 'Error de conexión' }));
    });
  };
};

export const setUserUpdate = (data) => ({
  type: types.userUpdate,
  payload: data,
});

export const createClient = (id, email, name, phone, rut, lastname) => {
  const url = `${API_URL}/clients`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      data: {
        numerointerno: id,
        email: email,
        name: name,
        phone: phone,
        rut: rut,
        lastname: lastname,
      },
    };
    axiosApi.post(url, params).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setCreateClient(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setCreateClient(outputData));
      }
    }).catch((err) => {
      dispatch(setCreateClient({ status: 'danger', message: err.response?.data?.message || 'Error de conexión' }));
    });
  };
};

export const setCreateClient = (data) => ({
  type: types.createClient,
  payload: data,
});

export const clientUpdate = (name, phone, email, rut, last_name) => {
  const url = `${API_URL}/clients`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      name: name,
      phone: phone,
      email: email,
      rut: rut,
      last_name: last_name,
    };
    axiosApi.put(url, params).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setClientUpdate(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['user'] = data.user;
        dispatch(setClientUpdate(outputData));
      }
    }).catch((err) => {
      dispatch(setClientUpdate({ status: 'danger', message: err.response?.data?.message || 'Error de conexión' }));
    });
  };
};

export const setClientUpdate = (data) => ({
  type: types.clientUpdate,
  payload: data,
});

export const clientList = (id) => {
  const url = id
    ? `${API_URL}/clients?numerointerno=${id}`
    : `${API_URL}/clients`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setClientList(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setClientList(outputData));
      }
    }).catch((err) => {
      dispatch(setClientList({ status: 'danger', message: err.response?.data?.message || 'Error de conexión', data: [] }));
    });
  };
};

export const setClientList = (data) => ({
  type: types.clientList,
  payload: data,
});

export const notify = (id, clients) => {
  const url = `${API_URL}/clients/notify`;

  return (dispatch) => {
    let outputData = {};
    let params = { numerointerno: id, clients: clients };
    axiosApi.post(url, params).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Invalid credentials!';
        dispatch(setNotify(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data;
        dispatch(setNotify(outputData));
      }
    }).catch((err) => {
      dispatch(setNotify({ status: 'danger', message: err.response?.data?.message || 'Error de conexión' }));
    });
  };
};

export const setNotify = (data) => ({
  type: types.notify,
  payload: data,
});

export const roleCreate = (name, privilege_level, permissions = {}) => {
  const url = `${API_URL}/api/auth/roles`;

  return (dispatch) => {
    let outputData = {};
    axiosApi.post(url, { name, privilege_level, permissions }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['role'] = data.role;
      }
      dispatch({ type: types.roleCreate, payload: outputData });
    }).catch((err) => {
      const message = err.response?.data?.message || 'Error de conexión. Intente nuevamente.';
      dispatch({ type: types.roleCreate, payload: { status: 'danger', message } });
    });
  };
};

export const roleUpdate = (id, name, privilege_level, permissions = {}) => {
  const url = `${API_URL}/api/auth/roles`;

  return (dispatch) => {
    let outputData = {};
    axiosApi.put(url, { id, name, privilege_level, permissions }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
      }
      dispatch({ type: types.roleUpdate, payload: outputData });
    }).catch((err) => {
      const message = err.response?.data?.message || 'Error de conexión. Intente nuevamente.';
      dispatch({ type: types.roleUpdate, payload: { status: 'danger', message } });
    });
  };
};

export const fetchPermissionRegistry = () => {
  const url = `${API_URL}/api/auth/permissions/registry`;

  return (dispatch) => {
    axiosApi.get(url).then(({ data }) => {
      dispatch({
        type: types.permissionRegistry,
        payload: { registry: data.registry },
      });
    }).catch((err) => {
      console.error('[fetchPermissionRegistry] Error:', err);
      dispatch({
        type: types.permissionRegistry,
        payload: { registry: null, error: err.response?.data?.message || 'Error al cargar el registro de permisos' },
      });
    });
  };
};

export const roleDelete = (id) => {
  const url = `${API_URL}/api/auth/roles`;

  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { data: { id } }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
      }
      dispatch({ type: types.roleDelete, payload: outputData });
    }).catch((err) => {
      const message = err.response?.data?.message || 'Error de conexión. Intente nuevamente.';
      dispatch({ type: types.roleDelete, payload: { status: 'danger', message } });
    });
  };
};
